import React from "react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { PageHero } from "@/components/site/PageHero";
import { SectionHeading } from "@/components/site/ui";
import { BuyerSection } from "@/components/site/BuyerSection";
import { FinancingSection } from "@/components/site/FinancingSection";
import { MortgageCalculator } from "@/components/site/MortgageCalculator";
import { FaqSection } from "@/components/site/FaqSection";
import { LeadForm } from "@/components/site/LeadForm";
import { ContactSection } from "@/components/site/ContactSection";
import { ROUTES } from "@/components/site/data";

const IMG = "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function BuyPage() {
  usePageMeta(
    "Buy a Home | Wallstreet Realty",
    "Buy with confidence in Southern California. Search homes, connect with a local buyer agent, and get real estate and mortgage guidance from Wallstreet Realty."
  );
  return (
    <>
      <PageHero
        crumb="Buy"
        eyebrow="For Buyers"
        title="Buy With Confidence"
        subtitle="First home, upgrade, downsize, or investment. We help you search smarter, understand your options, and move forward with a clear plan."
        image={IMG}
        ctas={[
          { label: "Search Homes", href: ROUTES.idx, testid: "buy-hero-search" , pill: true},
          { label: "Talk to a Buyer Agent", href: ROUTES.contact, variant: "gold", testid: "buy-hero-agent" },
        ]}
      />
      <BuyerSection />
      <section className="py-16 lg:py-24 bg-[#F5F5F5]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            eyebrow="Get Started"
            title="Request Buyer Help"
            subtitle="Tell us what you're looking for and a Wallstreet Realty buyer agent will reach out."
            center
          />
          <div className="mt-10">
            <LeadForm variant="buyer" testid="buyer-form" />
          </div>
        </div>
      </section>
      <FinancingSection />
      <MortgageCalculator />
      <FaqSection />
      <ContactSection />
    </>
  );
}
